import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { verifyEmail } from '../api/appApi';
import Swal from 'sweetalert2';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    if (!token) {
      navigate('/login');
      return;
    }
    const verify = async () => {
      try {
        const res = await verifyEmail(token);
        if (res?.success) {
          Swal.fire({ icon: 'success', title: 'Email Verified', timer: 1500, showConfirmButton: false });
        } else {
          Swal.fire({ icon: 'error', title: 'Verification Failed', text: res.message || 'Invalid or expired link.' });
        }
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Verification Failed', text: err.response?.data?.message || 'Verification failed.' });
      }
      navigate('/login');
    };
    verify();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Verifying...</span>
      </div>
    </div>
  );
};

export default VerifyEmail;
